import { render, staticRenderFns } from "./ApplicantMessageHistoryScout.vue?vue&type=template&id=61540d9f"
import script from "./ApplicantMessageHistoryScout.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageHistoryScout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports